/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snap from 'snapsvg';
import Dot from '../dot';
import { DEVICE } from '../../../../constants';
import DeviceContext from '../device-context';
import { generateCurve } from './boardPassGenerator';
import './style';

// pad端文字位置，1上0下
const padTextPos = [1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1];


// setTimeout(() => { window.setDownloaded({ list: 'RL1-01,RL1-08' }); }, 1000);

class Dots extends Component {
  static propTypes = {
    coordinates: PropTypes.array,
    stages: PropTypes.array,
    setSize: PropTypes.func,
    svgSetting: PropTypes.object,
    theme: PropTypes.string,
    stageId: PropTypes.string,
  };

  state = {
    downloaded: {},
    dlProgress: {},
    hasDownloadingDot: false,
  }

  componentDidMount() {
    this.snap = Snap('#svgDot');
    this.initDots();
    window.onfire.on('setDownloadBookProgress', (current) => {
      this.setDownloadBookProgress && this.setDownloadBookProgress(current);
    });
    window.onfire.on('setDownloaded', ({ downloaded }) => {
      this.setDownloaded(downloaded);
    });
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    window.onfire.off('setDownloadBookProgress');
    window.onfire.off('setDownloaded');
  }

  resize = () => {
    this.setText();
    this.context !== DEVICE.PC && setTimeout(this.getSize, 0);
  }

  initDots = () => {
    this.context === DEVICE.PC
      ? this.drawDotPc()
      : this.drawDotMobile();
  }

  drawDotMobile = () => {
    const { coordinates } = this.props;
    coordinates.forEach(item => this.drawDot(item));
    this.setText();
    setTimeout(this.getSize, 0);
  };

  drawDot = (coordinate) => {
    const transform = { transform: `translate(${coordinate.x},${+coordinate.y})` };
    const position = this.snap.use('position').attr(transform);
    this.snap.g(position).attr({ class: 'position' });
  }

  setText = () => {
    // 文字和点
    const gArr1 = this.snap.selectAll('.position');
    const gArr = Array.from(document.querySelectorAll('.position'));
    const snapCx = this.snap.getBBox().cx; // svg中心点
    const itemArr = Array.from(document.querySelectorAll('.dot-item'));
    const container = document.querySelector('.path');
    const windowWidth = document.documentElement.clientWidth;
    itemArr.forEach((item, index) => {
      const { cx } = gArr1[index].getBBox();
      const position = gArr[index].getBoundingClientRect();
      let transform = '';
      const text = item.querySelector('p');
      const dot = item.querySelector('.dot');
      if (this.context === DEVICE.MOBILE) {
        // 文字位置
        text.style.width = cx > snapCx ? `${position.left}px` : `${windowWidth - cx - dot.clientWidth - 15}px`;
        text.className = cx > snapCx ? 'text left' : 'text';
        item.style.width = cx > snapCx ? '' : `${windowWidth - cx}px`;
        transform = `
        translate(
          ${cx > snapCx ? 0 : position.left + 4}px,
          ${position.top + 1 - item.offsetTop + document.querySelector('.stage').scrollTop}px
        )
      `;
      } else if (this.context === DEVICE.PAD) {
        const up = padTextPos[index % padTextPos.length];
        text.className = up ? 'text up' : 'text down';
        if (up) {
          text.style.top = `-${text.clientHeight}px`;
        } else {
          text.style.top = `${dot.clientHeight + 10}px`;
        }
        transform = `
          translate(
            ${position.left + 4 - dot.offsetLeft + document.querySelector('.stage').scrollLeft}px,
            ${position.top + document.querySelector('.stage').scrollTop}px
          )
        `;
      } else {
        transform = `
        translate(
          ${position.left - container.offsetLeft + document.documentElement.scrollLeft - dot.clientWidth / 2}px,
          ${position.top - container.offsetTop + document.documentElement.scrollTop - dot.clientWidth / 2}px
        )
      `;
      }
      item.style.transform = transform;
    });
  }

  getSize = () => {
    const gArr = Array.from(document.querySelectorAll('.position'));
    gArr.length > 0 && this.props.setSize({
      width: gArr[gArr.length - 1].getBoundingClientRect().left
        + document.querySelector('.stage').scrollLeft + 200 / 1024 * document.documentElement.clientWidth,
      height: gArr[gArr.length - 1].getBoundingClientRect().top
        + document.querySelector('.stage').scrollTop + 100 / 375 * document.documentElement.clientWidth,
    });
  }

  setDownloadBookProgress = ({ id, current, size }) => {
    const percent = (parseInt(current, 10) / parseInt(size, 10)) * 100;
    // console.log('setDownloadBookProgress', { id, current, size }, percent);
    const { dlProgress } = this.state;
    percent > 0
      ? (dlProgress[id] = percent)
      : (dlProgress[id] && (delete dlProgress[id]));
    this.setState({
      dlProgress,
      hasDownloadingDot: (percent > 0 && percent < 100),
    });
  }

  setDownloaded = (arr) => {
    const downloaded = {};
    arr.forEach((item) => {
      downloaded[item] = true;
    });
    this.setState({ downloaded });
  }

  setDownloadingStatus = (hasDownloadingDot) => {
    // console.log('setDownloadingStatus - hasDownloadingDot: ', hasDownloadingDot);
    this.setState({ hasDownloadingDot });
  };

  drawDotPc =() => {
    generateCurve(this.props.coordinates, this.props.stages.length, '#svgDot');
    this.setText();
    setTimeout(this.getSize, 0);
  }

  render = () => {
    const { svgSetting, stageId, theme } = this.props;
    const { downloaded, dlProgress, hasDownloadingDot } = this.state;
    return (
      <React.Fragment>
        <svg id="svgDot" width={svgSetting.width} height={svgSetting.height} viewBox={`0 0 ${svgSetting.viewBox}`} preserveAspectRatio="xMinYMin meet">
          <defs>
            {/* 定位 */}
            <symbol id="position">
              <circle r=".5" cx="0" cy="0" />
            </symbol>
          </defs>
        </svg>
        <div className="dots">
          {this.props.stages.map(item => (
            <Dot
              stage={item}
              theme={theme}
              key={item.shortname}
              stageId={stageId}
              percent={dlProgress[item.shortname] ? dlProgress[item.shortname] : 0}
              downloaded={downloaded[item.shortname]}
              hasDownloadingDot={hasDownloadingDot}
              setDownloadingStatus={this.setDownloadingStatus}
            />
          ))}
        </div>
      </React.Fragment>
    );
  }
}

Dots.contextType = DeviceContext;

export default Dots;
